import VueRouter from "vue-router";
import RegisterKunjunganSvc from "@/services/RegisterKunjungan";
import EncounterIndex from "@/services/EncounterIndex";
import { pemeriksaanRouteName } from "@/utils/unit";

const TAB_PERSETUJUAN_DARAH = "tab-persetujuan-transfusi-darah";

function rmTampil(cm: string): string {
  const bersih = String(cm || "").trim();
  return bersih.length === 8 ? bersih.substring(2, 8) : bersih;
}

export async function bukaPemeriksaanBankDarah(
  router: VueRouter,
  registerId: string | number
): Promise<void> {
  const resp = await RegisterKunjunganSvc.get(registerId);
  const reg = resp && resp.data;
  if (!reg || !reg.no) return;

  const register = String(reg.no);
  const rm = rmTampil(reg.cm);
  const name = pemeriksaanRouteName(reg.unit);

  if (name === "pemeriksaan-ranap") {
    await EncounterIndex.regRanap(register, rm).catch(() => undefined);
    await router
      .push({
        name,
        params: { register, rm, page: "tab-persetujuan" },
        query: { topTab: "tab-persetujuan", tab: TAB_PERSETUJUAN_DARAH }
      })
      .catch(() => undefined);
    return;
  }

  await router
    .push({
      name,
      params: { register, rm },
      query: { topTab: "tab-suket", tab: TAB_PERSETUJUAN_DARAH, category: "Persetujuan" }
    })
    .catch(() => undefined);
}
